import { render, staticRenderFns } from "./airPurifiers.vue?vue&type=template&id=0fc4e7b6&"
import script from "./airPurifiers.vue?vue&type=script&lang=js&"
export * from "./airPurifiers.vue?vue&type=script&lang=js&"
import style0 from "./airPurifiers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports